import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { Construction as ConstructionIcon } from "@mui/icons-material";
import { ProjectTemplate } from "../../pages/contractor/planTypes";

interface Props {
  open: boolean;
  templates: ProjectTemplate[];
  loading: boolean;
  onSelect: (template: ProjectTemplate) => void;
  onClose: () => void;
}

export function TemplateSelector({ open, templates, loading, onSelect, onClose }: Props) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Choose a project template</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Select a template to pre-fill your plan with typical milestones. You can
          customize everything after loading.
        </Typography>

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
              gap: 2,
            }}
          >
            {templates.map((template) => (
              <Card key={template.id} variant="outlined">
                <CardActionArea onClick={() => onSelect(template)}>
                  <CardContent>
                    <Stack spacing={1}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <ConstructionIcon color="primary" fontSize="small" />
                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                          {template.name}
                        </Typography>
                      </Box>
                      <Typography variant="caption" color="text.secondary">
                        {template.description}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {template.milestones.length} milestones
                      </Typography>
                    </Stack>
                  </CardContent>
                </CardActionArea>
              </Card>
            ))}
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
